export default __webpack_public_path__ + "static/media/close.112a3318.svg";